import { render, staticRenderFns } from "./Universe.vue?vue&type=template&id=e7be24b0&"
import script from "./Universe.vue?vue&type=script&lang=js&"
export * from "./Universe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports